export const SET_PORTFOLIOS = "SET_PORTFOLIOS";
export const SET_PORTFOLIO = "SET_PORTFOLIO";
export const SET_SELECTED_ENTITY = "SET_SELECTED_ENTITY";
export const SET_SELECTED_PORTFOLIO = "SET_SELECTED_PORTFOLIO";
export const ADD_PORTOLIO = "ADD_PORTOLIO";
export const REMOVE_PORTFOLIO = "REMOVE_PORTFOLIO";
export const SET_ALL_PORTFOLIOS = "SET_ALL_PORTFOLIOS";
